var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClevertapinline = function SvgClevertapinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#E73737"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.913 13a4.89 4.89 0 0 1-4.175-2.346 5.03 5.03 0 0 1-.61-3.752A4.97 4.97 0 0 1 5.312 3.81a.39.39 0 0 1 .54.127.4.4 0 0 1-.125.548 4.18 4.18 0 0 0-1.835 2.598 4.22 4.22 0 0 0 .512 3.151c.285.467.658.871 1.098 1.19.44.32.939.548 1.466.67a4.04 4.04 0 0 0 3.112-.52.39.39 0 0 1 .54.127.4.4 0 0 1-.126.548c-.774.49-1.668.75-2.581.751M11.337 11.72c.227 0 .41-.187.41-.417a.414.414 0 0 0-.41-.416.414.414 0 0 0-.411.416c0 .23.184.416.41.416"
  })));
};
export default SvgClevertapinline;